module.exports = __webpack_public_path__ + "static/media/exhibition.f467d0c2.svg";